import {
	FCM_ENABLE_VISION_FE_HELLOWORLD,
	FCM_STARTER_EXPERIENCE_DASHBOARD_TABS,
	FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
} from '@change-corgi/fcm/configs';

import { createExperimentFcmConfig } from 'src/app/shared/hooks/experiment';

export const FCM_EXPERIMENT_HELLO_WORLD = createExperimentFcmConfig({
	experimentName: FCM_ENABLE_VISION_FE_HELLOWORLD.name,
	fcmConfigs: {
		enabled: FCM_ENABLE_VISION_FE_HELLOWORLD,
	},
	isEnabled: ({ fcm: { enabled } }) => enabled,
});

export const FCM_EXPERIMENT_DASHBOARD_TABS = createExperimentFcmConfig({
	experimentName: 'starter_experience_dashboard_tabs_v03',
	fcmConfigs: {
		enabled: FCM_STARTER_EXPERIENCE_DASHBOARD_TABS,
	},
	isEnabled: ({ fcm }) =>
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		!!fcm.enabled?.isEnabled,
});

export const FCM_EXPERIMENT_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS_V03 = createExperimentFcmConfig({
	experimentName: 'starter_experience_share_recommendations_v03',
	fcmConfigs: {
		config: FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
	},
	// Disabling the rule because the config is not always present. e.g. the fcm is turned off.
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	isEnabled: ({ fcm }) => !!fcm.config?.isEnabled,
});

export const FCM_EXPERIMENT_STARTER_EXPERIENCE_GROUP_RECS_NEW_DESIGN = createExperimentFcmConfig({
	experimentName: 'starter_experience_group_recs_new_design',
	fcmConfigs: {
		config: FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
	},
	// Disabling the rule because the config is not always present. e.g. the fcm is turned off.
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	isEnabled: ({ fcm }) => !!fcm.config?.isEnabled,
});
